import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Paper,
  TextField,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

import { BuildingFaq, BuildingFaqItem } from "../../../graphql/models";
import { WithI18n } from "../../../i18n";
import { useEffect, useState } from "react";
import { I18NTextField } from "../i18n_text_field";

export interface pBuildingFaq extends WithI18n<"category"> {
  index: number;
  items: pBuildingFaqItem[];
}

export interface pBuildingFaqItem extends WithI18n<"label" | "description"> {
  index: number;
}

export function BuildingFaqMediatorIn(faqs?: BuildingFaq[]): pBuildingFaq[] {
  let _faqs: pBuildingFaq[] = [];
  if (faqs) {
    _faqs = faqs.map((item, index) => {
      const o: pBuildingFaq = {
        index: index * 10,
        items: item.items.map((subItem, subIndex) => {
          const oo: pBuildingFaqItem = {
            ...subItem,
            index: subIndex * 10,
          };
          return oo;
        }),
        i18n: item.i18n,
      };
      return o;
    });
  }
  return _faqs;
}

export function BuildingFaqMediatorOut(items?: pBuildingFaq[]): BuildingFaq[] {
  if (!items) return [];
  const result = items.sort((a, b) => a.index - b.index);
  result.forEach((element) => {
    element.items.sort((a, b) => a.index - b.index);
  });
  const r = result.map((c) => {
    const m: BuildingFaq = {
      i18n: c.i18n,
      items: c.items.map((f) => {
        const d: BuildingFaqItem = {
          i18n: f.i18n,
        };
        return d;
      }),
    };
    return m;
  });
  console.info(`result is `, JSON.parse(JSON.stringify(r)));
  return r;
}

export interface BuildingFaqsEditorProps {
  faqs: pBuildingFaq[];
  onChange: (v: pBuildingFaq[]) => void;
}

export interface BuildingFaqsItemEditorProps {
  item: pBuildingFaqItem;
  key: string;
  onChange: (v: pBuildingFaqItem) => void;
}

export interface BuildingFaqsCategoryEditorProps {
  item: pBuildingFaq;
  key: string;
  onChange: (v: pBuildingFaq) => void;
}

export function BuildingFaqsEditor(props: BuildingFaqsEditorProps) {
  const { faqs } = props;
  console.log(`faqs length is ${faqs?.length}`);

  const onUpdateHandler = (v: pBuildingFaq, i: number) => {
    console.log(`new object for index ${i} is `, JSON.parse(JSON.stringify(v)));
    const arr = [...faqs];
    arr.splice(i, 1, v);
    props.onChange(arr);
  };

  const onNewHandler = () => {
    console.info("new category");
    props.onChange([...faqs, { i18n: {}, items: [], index: 0 }]);
  };

  return (
    <Paper elevation={3} style={{ width: "100%", padding: "1rem" }}>
      {faqs.map((faqCategory, index) => {
        return (
          <BuildingFaqsCategoryEditor
            key={`faqCategory${index}`}
            item={faqCategory}
            onChange={(v) => onUpdateHandler(v, index)}
          ></BuildingFaqsCategoryEditor>
        );
      })}
      <Button color="primary" endIcon={<AddIcon />} onClick={onNewHandler}>
        Aggiungi Categoria
      </Button>
    </Paper>
  );
}

export function BuildingFaqsCategoryEditor(
  props: BuildingFaqsCategoryEditorProps
) {
  const { item, key } = props;
  const [index, setIndex] = useState(item.index);
  const [i18n, setI18n] = useState(item.i18n);
  const [items, setItems] = useState(item.items || []);

  const newFaqHandler = () => {
    const newFaq: pBuildingFaqItem = {
      index: 0,
      i18n: {},
    };
    setItems([...items, newFaq]);
  };

  const updateFaqHandler = (faq: pBuildingFaqItem, index: number) => {
    // console.info(`updated faq is `, JSON.parse(JSON.stringify(faq)));
    const v = [...items];
    v.splice(index, 1, faq);
    // console.log(`new collection is `, JSON.parse(JSON.stringify(v)));
    setItems(v);
  };

  useEffect(() => {
    // console.log(`notify onChange`);
    props.onChange({ ...item, index, i18n, items });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, index, i18n]);
  return (
    <Grid container spacing={3} key={key}>
      <Grid item sm={4} md={3}>
        <TextField
          label="Ordine"
          variant="outlined"
          style={{ width: "100%" }}
          value={index}
          onChange={(e) => setIndex(Number.parseInt(e.target.value))}
          type="number"
        ></TextField>
        <I18NTextField
          label="Categoria"
          variant="outlined"
          style={{ width: "100%" }}
          i18nFieldName="category"
          value={i18n}
          onChange={setI18n}
        ></I18NTextField>
        <Button color="primary" endIcon={<AddIcon />} onClick={newFaqHandler}>
          Aggiungi FAQ
        </Button>
      </Grid>
      <Grid item sm={8} md={9}>
        {items.map((faq, index) => (
          <BuildingFaqsItemEditor
            key={`faq${index}`}
            item={faq}
            onChange={(v) => updateFaqHandler(v, index)}
          ></BuildingFaqsItemEditor>
        ))}
      </Grid>
    </Grid>
  );
}

export function BuildingFaqsItemEditor(props: BuildingFaqsItemEditorProps) {
  const { item } = props;
  const [index, setIndex] = useState(item.index);
  const [i18n, setI18n] = useState(item.i18n);
  const [isChanged, setIsChanged] = useState(false);

  const onClickHandler = () => {
    const newItem: pBuildingFaqItem = {
      ...item,
      i18n,
      index,
    };
    props.onChange(newItem);
  };

  useEffect(() => {
    let b = true;
    if (index === item.index) {
      if (
        i18n?.label_it === item.i18n?.label_it &&
        i18n?.label_en === item.i18n?.label_en
      ) {
        if (
          i18n?.description_it === item.i18n?.description_it &&
          i18n?.description_en === item.i18n?.description_en
        ) {
          b = false;
        }
      }
    }
    setIsChanged(b);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index, i18n]);

  return (
    <Card variant="outlined">
      <CardContent>
        <TextField
          label="Ordine"
          variant="outlined"
          style={{ width: "100%" }}
          value={index}
          onChange={(e) => setIndex(Number.parseInt(e.target.value))}
          type="number"
        ></TextField>
        <I18NTextField
          label="Domanda"
          variant="outlined"
          style={{ width: "100%" }}
          i18nFieldName="label"
          value={i18n}
          onChange={setI18n}
        ></I18NTextField>
        <I18NTextField
          label="Risposta"
          variant="outlined"
          style={{ width: "100%" }}
          i18nFieldName="description"
          value={i18n}
          onChange={setI18n}
          multiline
          rows={4}
        ></I18NTextField>
      </CardContent>
      <CardActions>
        <Button
          variant="outlined"
          disabled={!isChanged}
          onClick={onClickHandler}
        >
          Conferma le modifiche
        </Button>
      </CardActions>
    </Card>
  );
}
